import clsx from 'clsx';
import { Button } from '../../../../shared/ui/button/Button';
import { ArrowDownIcon, ArrowUpIcon } from '../../../../shared/ui/icons';
import { CampaignCadenceStepSlot } from './CampaignCadenceStepSlot';
import styles from './CampaignCadenceCard.module.css';

export function CampaignCadenceStepCard({
  step,
  stepIndex,
  stepNumber,
  totalSteps,
  languages,
  isEditing = false,
  onMoveStepUp,
  onMoveStepDown,
  onMoveTemplateToStep,
  onPreview,
  onEdit,
}) {
  return (
    <div className={clsx(styles.card)}>
      <div className={clsx(styles.row)}>
        {isEditing && (
          <div className={clsx(styles.controls)}>
            <Button
              variant="outline"
              className={clsx(styles.arrowBtn)}
              onClick={onMoveStepUp}
              disabled={stepNumber === 1}
              aria-label="Move step up"
            >
              <ArrowUpIcon />
            </Button>
            <Button
              variant="outline"
              className={clsx(styles.arrowBtn)}
              onClick={onMoveStepDown}
              disabled={stepNumber === totalSteps}
              aria-label="Move step down"
            >
              <ArrowDownIcon />
            </Button>
          </div>
        )}

        {languages.map((language) => (
          <CampaignCadenceStepSlot
            key={language}
            item={step.itemsByLanguage[language] ?? null}
            language={language}
            stepIndex={stepIndex}
            stepNumber={stepNumber}
            totalSteps={totalSteps}
            isEditing={isEditing}
            onMoveToStep={(targetStep) => onMoveTemplateToStep?.(language, targetStep)}
            onPreview={onPreview}
            onEdit={onEdit}
          />
        ))}
      </div>
    </div>
  );
}
